import { select, put, take } from 'redux-saga/effects';

import { USER_LOGGED_IN } from 'actionTypes/actionBundles';
import { getResult } from 'actions';

import { selectUserResult } from 'selectors';

// Only care about this when we first load the app
function* userResultSaga() {
  // on start up
  const userResult = yield select(state => {
    return selectUserResult(state);
  });

  const shouldFetch = yield select(state => {
    return (
      !state.auth.currentUserId ||
      !userResult.uuid ||
      userResult.status === 'pending'
    );
  });

  if (shouldFetch) {
    yield put(getResult());
  }

  // eternal
  while (true) {
    yield take(USER_LOGGED_IN);
    yield put(getResult());
  }
}

export default userResultSaga();



// WEBPACK FOOTER //
// ./src/sagas/eternalSagas/userResultSaga.js